import { Component, OnInit } from '@angular/core';
import { LoginService } from './login.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  formLogin: FormGroup;
  incorrectCredentials = false;
  tempCompanyRoles: any;
  serverImagesUrl = 'https://s3.amazonaws.com/rrhh-images/company/logos/';
  waitLogin = false;

  isUsedCodeVerify = false;
  showCodeInput = false;
  digitsNumber = 6;
  codeForm!: FormGroup;

  constructor(
    private loginService: LoginService,
    private router: Router,
    private fb: FormBuilder,
    private totastrService: ToastrService
  ) {
    this.formLogin = new FormGroup({
      email: new FormControl('',
        [
          Validators.required
        ]
      ),
      password: new FormControl('',
        [
          Validators.required
        ]
      )
    });
  }

  ngOnInit() {
    this.codeForm = this.fb.group({
      digits: this.fb.array(
        Array(this.digitsNumber).fill('').map(() => this.fb.control('', [
          Validators.required,
          Validators.pattern(/^[0-9]$/)
        ]))
      )
    });
  }

  sendDataUser() {
    this.waitLogin = true;
    var userLogin = this.formLogin.value;
    userLogin['url'] = "serp";
    userLogin['appId'] = 9;
    if (this.showCodeInput) {
      var code = this.digits.value.join('');
      userLogin['authToken'] = code;
    }

    this.loginService.sendLoginUser(userLogin).subscribe(
      (response) => {
        var success = Object(response)['data'];
        if (success.verify) {
          if (this.showCodeInput) {
            this.setData(success);
          } else {
            this.waitLogin = false;
            this.showCodeInput = true;
            this.isUsedCodeVerify = true;
            this.totastrService.info('Se ha enviado un código de verificación.', 'Verificación requerida');
          }
        } else {
          this.setData(success);
        }
      },
      (error) => {
        this.waitLogin = false;
        this.incorrectCredentials = true;
        setTimeout(() => { this.incorrectCredentials = false }, 10000);
      }
    );
  }

  setData(success: any) {
    console.log(success);
    localStorage.setItem('jwt', success.token);
    localStorage.setItem('companyRoles', success.companyRoles);
    this.tempCompanyRoles = success.companyRoles;
    this.imageUrlRefractor();
    var currentUser =
    {
      id: success.id,
      firstName: success.firstName,
      lastName: success.lastName,
      mail: success.email,
      imageUrl: 'https://s3.amazonaws.com/rrhh-images/user/image/' + success.image,
      country: success.country,
      defaultCompany: success.defaultCompany,
      services: success.services,
      alphanumericId: success.alphanumericId,
      companyRoles: this.tempCompanyRoles,
      countryId: success.countryId,
      canAdminUsers: success.canAdminUsers,
      canAdminCompanies: success.canAdminCompanies,
      seller: success.seller,
      adviser: success.adviser,
      validated: success.validated,
      balance: success.balance,
      currency: success.currency,
      passOk: success.passOk,
      associate: success.associate,
      admin: success.admin,
      directAdviser: success.directAdviser,
      credit: success.credit,
      companiesReservedBalance: success.companiesReservedBalance,
      allRolesInCompanies: [],
      contadorGT: success.contadorGT,
      userPartner: success.userPartner
    };
    localStorage.setItem('user', JSON.stringify(currentUser));
    localStorage.setItem('allServices', JSON.stringify(currentUser.services));
    this.loginService.getRoleUser().subscribe(
      (response) => {
        currentUser.allRolesInCompanies = Object(response);
        localStorage.setItem('user', JSON.stringify(currentUser));
        this.waitLogin = false;
        this.router.navigate(['select-company']);
      },
      (error) => {
        console.log("Error al obtener los roles del usuario " + error);
      }
    );
  }

  sendCode() {
    if (!this.isUsedCodeVerify) {
      return;
    }
    this.waitLogin = true;
    var userLogin = this.formLogin.value;
    userLogin['url'] = "serp";
    userLogin['appId'] = 9;
    this.loginService.sendLoginUser(userLogin).subscribe(
      (response) => {
        this.waitLogin = false;
        this.showCodeInput = true;
        this.totastrService.info('Se ha enviado un nuevo código de verificación.', 'Verificación requerida');
      },
      (error) => {
        this.waitLogin = false;
        this.incorrectCredentials = true;
        this.showCodeInput = false;
        this.totastrService.error('No se pudo enviar un nuevo código de verificación. Por favor, intente iniciar sesión de nuevo.', 'Error');
        setTimeout(() => { this.incorrectCredentials = false }, 10000);
      }
    );
  }

  imageUrlRefractor() {
    for (var i = 0; i < this.tempCompanyRoles.length; i++) {
      var companyLogo = this.tempCompanyRoles[i].companyLogo;
      var newCompanyLogo = "/images/company-avatar2.png";
      if (companyLogo !== null) {
        newCompanyLogo = this.serverImagesUrl + companyLogo;
      }
      this.tempCompanyRoles[i].companyLogo = newCompanyLogo;
    }
  };

  get digits(): FormArray {
    return this.codeForm.get('digits') as FormArray;
  }

  onInput(event: any, index: number) {
    const input = event.target;
    const value = input.value;

    // Si pega varios dígitos
    if (value.length > 1) {
      this.pasteCode(value);
      return;
    }

    // Si el valor es válido, mover al siguiente input
    if (value && index < 5) {
      const next = document.getElementById('digit-' + (index + 1));
      next?.focus();
    }

    this.checkCompleted();
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;

    // Si presiona backspace estando vacío → ir al input anterior
    if (event.key === 'Backspace' && !input.value && index > 0) {
      const prev = document.getElementById('digit-' + (index - 1));
      prev?.focus();
      // prev?.select();
    }
  }

  pasteCode(value: string) {
    const clean = value.replace(/\D/g, '').slice(0, 6); // Solo números

    clean.split('').forEach((char, i) => {
      this.digits.at(i).setValue(char);
    });

    const lastIndex = clean.length - 1;
    if (lastIndex >= 0) {
      const last = document.getElementById('digit-' + lastIndex);
      last?.focus();
    }

    this.checkCompleted();
  }

  checkCompleted() {
    if (this.codeForm.valid) {
      const code = this.digits.value.join('');
      // this.onComplete.emit(code);
    }
  }
}